import type { ReactNode } from 'react';

export const symbol_line_start_square: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-320h320v-320H140v320Zm-30 60q-12.75 0-21.37-8.63Q80-277.25 80-290v-380q0-12.75 8.63-21.38Q97.25-700 110-700h380q12.75 0 21.38 8.62Q520-682.75 520-670v160h330q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H520v160q0 12.75-8.62 21.37Q502.75-260 490-260H110Zm190-220Z"
		/>
	</svg>
);
